<template>
    <div class="main-container">
        <NavbarComponent
            :hasDropdown="true"
            :username="`${firstName} ${lastName}`"
            @logoClick="currentPage > 0 && currentPage <= 2 ? currentPage = 0 : $router.push('/')"
            @historyClick="currentPage = 1"
            @spotClick="currentPage = 0"
            @accountClick="currentPage = 2"
            @logout="onLogout"
        />
        <AdEditComponent
            v-if="currentPage === 0"
            dashboard
            fetch
            @updated="onUpdate"
        />
        <InvoiceListComponent
            v-if="currentPage === 1"
            :invoices="sharedState.invoices"
        />
        <EditAccountComponent
            v-if="currentPage === 2"
        />
    </div>
</template>

<script>
import AdEditComponent from '@/components/AdEditComponent';
import NavbarComponent from '@/components/NavbarComponent';
import InvoiceListComponent from '@/components/InvoiceListComponent';
import EditAccountComponent from '@/components/EditAccountComponent';
import store from '@/services/business/store';

export default {
    name: 'DashboardPage',
    metaInfo: {
		title: 'Dashboard - LensAdvisors Business',
		meta: [
			{ vmid: 'description', name: 'description', content: 'Manage your ads on LensAdvisors' }
		]
	},
    components: {
        AdEditComponent,
        InvoiceListComponent,
        EditAccountComponent,
        NavbarComponent
    },
    data: () => {
        return {
            sharedState: store.state,
            currentPage: 0,
            get username() {
                return window.localStorage.getItem('userEmail');
            },
            get firstName() {
                return window.localStorage.getItem('userFirst');
            },
            get lastName() {
                return window.localStorage.getItem('userLast');
            }
        }
    },
    methods: {
        onUpdate() {
            store.updateAd(this.sharedState.adInfo);
        },
        onLogout() {
            store.logout(() => {
                this.$router.push('/');
            });
        }
    },
    created() {
        store.getInvoices();
    }
};
</script>

<style lang="scss" scoped>
    .main-container {
        width: 100vw;
    }
</style>